<template>
  <header class="container-fluid">
    <div class="container">
      <div class="row">
        <div class="col-sm-2 col-2">
          <router-link to="/" class="logo-link">
            <img class="logo" src="/images/irpo_logo_white.svg" alt="logo">
          </router-link>
        </div>
        <div class="col-2 burger-menu col-md-1" @click="showMenu = !showMenu">
          <svg class="burger-menu__icon" >
            <use xlink:href="#burger"></use>
          </svg>
        </div>
        <div class="col-sm menu align-self-center">
          <ul class="nav justify-content-end">
            <li class="nav-item">
              <router-link class="nav-link" to="/competencies" exact>Оценочные материалы</router-link>
            </li>

            <li class="nav-item">
              <router-link class="nav-link" to="/archive">Архив</router-link>
            </li>

          </ul>
        </div>
      </div>
    </div>

    <app-mobile-menu v-show="showMenu" @close="showMenu = false"></app-mobile-menu>

  </header>
</template>

<script>
import { AppMobileMenu } from "@/components";

export default {
  name: "Header",
  components: { AppMobileMenu },
  data: () => ({
    showMenu: false
  }),
  watch: {
    $route() {
      this.showMenu = false;
    }
  }
};
</script>

<style scoped lang="scss">
.container-fluid {
  background-image: url(/images/header-bg-home.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 29px;
  padding-bottom: 18px;
  max-width: 2560px;
}

.menu {
  padding: 0;
  padding-right: 15px;
}

.burger-menu {
  text-align: right;
}

.logo {
  height: 69px;
}

.nav-link {
  align-self: center;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  padding: 5px;
  padding-bottom: 2px;
}

.nav-item {
  display: flex;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }
}

@include media-breakpoint-up(xl) {
  .burger-menu {
    display: none;
  }
}
@include media-breakpoint-down(lg) {
  .menu {
    display: none;
  }
}

@include media-breakpoint-down(lg) {
  .row {
    justify-content: space-between;
  }
}

@include media-breakpoint-down(sm) {
  .container-fluid {
    padding-left: 22px;
    padding-right: 30px;
    padding-bottom: 27px;
  }

  .container {
    padding-left: 0;
    padding-right: 0;
  }

  .logo-link {
    padding-left: 5px;
  }
}
</style>
